import React from "react";
import { get } from "lodash";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";

type SelectInputProps = {
  label: string;
  name: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLSelectElement>;
  onBlur?: () => void;
  options: string[];
  required?: boolean;
  form?: any;
};

export default function SelectInput({
  onChange,
  label,
  form,
  name,
  options,
  value,
}: SelectInputProps) {
  const id = name;
  const fieldError = get(form, `errors[${name}]`);
  const fieldTouched = get(form, `touched[${name}]`);
  const hasError = fieldTouched && !!fieldError;
  const helperText = hasError ? fieldError : " ";

  return (
    <Form.Group as={Col} className="mb-3" controlId={id}>
      <Form.Label>{label}</Form.Label>
      <Form.Select value={value} onChange={onChange}>
        {options.map((option: string) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </Form.Select>
      {hasError && (
        <Form.Text id={`${id}--error`} className="text-danger">
          {helperText}
        </Form.Text>
      )}
    </Form.Group>
  );
}
